import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const Container = styled.div`
  padding-left: 154px;
  box-sizing: border-box;
  width: 100%;
  height: 75%;
  max-height: 850px;
  z-index: 2;

  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .subTitleContainer {
    p {
      margin: 0;
      padding: 0;
    }
  }

  ${theme.breakpoints.down('md')} {
    padding: 0 27px;
  }

  button {
    margin-bottom: 20px;
  }
`

export const SubTitle = styled.div`
  font-family: CenturyGothic, sans-serif;
  color: ${theme.colors.blue900};
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 40px;

  ul {
    margin: 0;
    padding: 0;
    margin-left: 19px;
  }

  ${theme.breakpoints.down('lg')} {
    font-size: 15px;
  }
  ${theme.breakpoints.down('md')} {
    font-size: 13px;
  }
  ${theme.breakpoints.down('sm')} {
    margin-bottom: 20px;
  }
  font-weight: ${prop => (prop.isBold ? 'bold' : 'normal')};
`
